//# sourceMappingURL=length.mjs.map
/// <reference types="./length.d.mts" />
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

class Px extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cm extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Mm extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Q extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class In extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Pc extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Pt extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vh extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vw extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Em extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rem extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Lh extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rlh extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Ch extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Pct extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cap extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Ex extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Ic extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rcap extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rch extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rex extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Ric extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vmax extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vmin extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vb extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Vi extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqw extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqh extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqi extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqb extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqmin extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Cqmax extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

/**
 * One pixel. For screen displays, it traditionally represents one device pixel
 * (dot). However, for _printers_ and _high-resolution screens_, one CSS pixel
 * implies multiple device pixels. `1px = 1in / 96`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#px)
 */
export function px(value) {
  return new Px($int.to_float(value));
}

/**
 * One pixel. For screen displays, it traditionally represents one device pixel
 * (dot). However, for _printers_ and _high-resolution screens_, one CSS pixel
 * implies multiple device pixels. `1px = 1in / 96`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#px)
 */
export function px_(value) {
  return new Px(value);
}

/**
 * One centimeter. `1cm = 96px / 2.54`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cm)
 */
export function cm(value) {
  return new Cm($int.to_float(value));
}

/**
 * One centimeter. `1cm = 96px / 2.54`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cm)
 */
export function cm_(value) {
  return new Cm(value);
}

/**
 * One millimeter. `1mm = 1cm / 10`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#mm)
 */
export function mm(value) {
  return new Mm($int.to_float(value));
}

/**
 * One millimeter. `1mm = 1cm / 10`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#mm)
 */
export function mm_(value) {
  return new Mm(value);
}

/**
 * One quarter of a millimeter. `1Q = 1cm / 40`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#q)
 */
export function q(value) {
  return new Q($int.to_float(value));
}

/**
 * One quarter of a millimeter. `1Q = 1cm / 40`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#q)
 */
export function q_(value) {
  return new Q(value);
}

/**
 * One inch. `1in = 2.54cm = 96px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#in)
 */
export function in$(value) {
  return new In($int.to_float(value));
}

/**
 * One inch. `1in = 2.54cm = 96px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#in)
 */
export function in_(value) {
  return new In(value);
}

/**
 * One pica. `1pc = 12pt = 1in / 6`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#pc)
 */
export function pc(value) {
  return new Pc($int.to_float(value));
}

/**
 * One pica. `1pc = 12pt = 1in / 6`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#pc)
 */
export function pc_(value) {
  return new Pc(value);
}

/**
 * One point. `1pt = 1in / 72`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#pt)
 */
export function pt(value) {
  return new Pt($int.to_float(value));
}

/**
 * One point. `1pt = 1in / 72`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#pt)
 */
export function pt_(value) {
  return new Pt(value);
}

/**
 * Represents the "cap height" (nominal height of capital letters) of the element's
 * [font](https://developer.mozilla.org/docs/Web/CSS/font).
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cap)
 */
export function cap(value) {
  return new Cap(value);
}

/**
 * Represents a percentage value. It is often used to define a size as relative
 * to an element's parent object. Numerous properties can use percentages,
 * such as `width`, `height`, `margin`, `padding`, and `font-size`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/percentage)
 */
export function percent(value) {
  return new Pct($int.to_float(value));
}

/**
 * Represents a percentage value. It is often used to define a size as relative
 * to an element's parent object. Numerous properties can use percentages,
 * such as `width`, `height`, `margin`, `padding`, and `font-size`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/percentage)
 */
export function percent_(value) {
  return new Pct(value);
}

/**
 * Represents a percentage of the height of the viewport's initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block).
 * `1cqh` is 1% of the query container's height. For example, if the viewport height is
 * `300px`, then a value of `70vh` on a property will be `210px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vh)
 */
export function vh(value) {
  return new Vh($int.to_float(value));
}

/**
 * Represents a percentage of the height of the viewport's initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block).
 * `1cqh` is 1% of the query container's height. For example, if the viewport height is
 * `300px`, then a value of `70vh` on a property will be `210px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vh)
 */
export function vh_(value) {
  return new Vh(value);
}

/**
 * Represents a percentage of the width of the viewport's initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block).
 * `1vw` is 1% of the viewport width. For example, if the viewport width is
 * `800px`, then a value of `50vh` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vw)
 */
export function vw(value) {
  return new Vw($int.to_float(value));
}

/**
 * Represents a percentage of the width of the viewport's initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block).
 * `1vw` is 1% of the viewport width. For example, if the viewport width is
 * `800px`, then a value of `50vh` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vw)
 */
export function vw_(value) {
  return new Vw(value);
}

/**
 * Represents in percentage the larget of `vw` and `vh`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vmax)
 */
export function vmax(value) {
  return new Vmax($int.to_float(value));
}

/**
 * Represents in percentage the larget of `vw` and `vh`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vmax)
 */
export function vmax_(value) {
  return new Vmax(value);
}

/**
 * Represents in percentage the smallest of `vw` and `vh`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vmin)
 */
export function vmin(value) {
  return new Vmin($int.to_float(value));
}

/**
 * Represents in percentage the smallest of `vw` and `vh`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vmin)
 */
export function vmin_(value) {
  return new Vmin(value);
}

/**
 * Represents the percentage of the size of the initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block),
 * in the direction of the root element's [block axis](https://developer.mozilla.org/docs/Web/CSS/CSS_logical_properties_and_values).
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vb)
 */
export function vb(value) {
  return new Vb($int.to_float(value));
}

/**
 * Represents the percentage of the size of the initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block),
 * in the direction of the root element's [block axis](https://developer.mozilla.org/docs/Web/CSS/CSS_logical_properties_and_values).
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vb)
 */
export function vb_(value) {
  return new Vb(value);
}

/**
 * Represents the percentage of the size of the initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block),
 * in the direction of the root element's [inline axis](https://developer.mozilla.org/docs/Web/CSS/CSS_logical_properties_and_values).
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vi)
 */
export function vi(value) {
  return new Vi($int.to_float(value));
}

/**
 * Represents the percentage of the size of the initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block),
 * in the direction of the root element's [inline axis](https://developer.mozilla.org/docs/Web/CSS/CSS_logical_properties_and_values).
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#vi)
 */
export function vi_(value) {
  return new Vi(value);
}

/**
 * Represents a percentage of the height of the viewport's initial
 * [containing block](https://developer.mozilla.org/docs/Web/CSS/Containing_block).
 * `1vh` is 1% of the viewport height. For example, if the query container's height is
 * `300px`, then a value of `70vh` on a property will be `210px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqh)
 */
export function cqh(value) {
  return new Cqh($int.to_float(value));
}

/**
 * Represents a percentage of the height of the query container.
 * `1cqh` is 1% of the query container's height. For example, if the query container's height is
 * `300px`, then a value of `70vh` on a property will be `210px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqh)
 */
export function cqh_(value) {
  return new Cqh(value);
}

/**
 * Represents a percentage of the width of the query container.
 * `1cqw` is 1% of the query container's width. For example, if the query container's width is
 * `800px`, then a value of `50vh` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqw)
 */
export function cqw(value) {
  return new Cqw($int.to_float(value));
}

/**
 * Represents a percentage of the width of the query container.
 * `1cqw` is 1% of the query container's width. For example, if the query container's width is
 * `800px`, then a value of `50vh` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqw)
 */
export function cqw_(value) {
  return new Cqw(value);
}

/**
 * Represents a percentage of the larger value of either the query container's
 * inline size or block size. `1cqmax` is 1% of the larger value of either the
 * query container's inline size or block size. For example, if the query
 * container's inline size is `800px` and its block size is `300px`, then a
 * value of `50cqmax` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqmax)
 */
export function cqmax(value) {
  return new Cqmax($int.to_float(value));
}

/**
 * Represents a percentage of the larger value of either the query container's
 * inline size or block size. `1cqmax` is 1% of the larger value of either the
 * query container's inline size or block size. For example, if the query
 * container's inline size is `800px` and its block size is `300px`, then a
 * value of `50cqmax` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqmax)
 */
export function cqmax_(value) {
  return new Cqmax(value);
}

/**
 * Represents a percentage of the smaller value of either the query container's
 * inline size or block size. `1cqmin` is 1% of the smaller value of either the
 * query container's inline size or block size. For example, if the query
 * container's inline size is `800px` and its block size is `300px`, then a
 * value of `50cqmin` on a property will be `150px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqmin)
 */
export function cqmin(value) {
  return new Cqmin($int.to_float(value));
}

/**
 * Represents a percentage of the smaller value of either the query container's
 * inline size or block size. `1cqmin` is 1% of the smaller value of either the
 * query container's inline size or block size. For example, if the query
 * container's inline size is `800px` and its block size is `300px`, then a
 * value of `50cqmin` on a property will be `150px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqmin)
 */
export function cqmin_(value) {
  return new Cqmin(value);
}

/**
 * Represents a percentage of the block size of the query container. `1cqb` is
 * 1% of the query container's block size. For example, if the query container's
 * block size is `300px`, then a value of `10cqb` on a property will be `30px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqb)
 */
export function cqb(value) {
  return new Cqb($int.to_float(value));
}

/**
 * Represents a percentage of the block size of the query container. `1cqb` is
 * 1% of the query container's block size. For example, if the query container's
 * block size is `300px`, then a value of `10cqb` on a property will be `30px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqb)
 */
export function cqb_(value) {
  return new Cqb(value);
}

/**
 * Represents a percentage of the inline size of the query container. `1cqi`
 * is 1% of the query container's inline size. For example, if the query container's
 * inline size is `800px`, then a value of `50cqi` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqi)
 */
export function cqi(value) {
  return new Cqi($int.to_float(value));
}

/**
 * Represents a percentage of the inline size of the query container. `1cqi`
 * is 1% of the query container's inline size. For example, if the query container's
 * inline size is `800px`, then a value of `50cqi` on a property will be `400px`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#cqi)
 */
export function cqi_(value) {
  return new Cqi(value);
}

/**
 * Represents the calculated `font-size` of the element. If used on the
 * `font-size` property itself, it represents the _inherited_ font-size of
 * the element.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#em)
 */
export function em(value) {
  return new Em(value);
}

/**
 * Represents the [x-height](https://en.wikipedia.org/wiki/X-height) of the
 * element's `font`. In fonts with the `x` letter, this is generally the height
 * of lowercase letters in the font; `1ex ≈ 0.5em` in many fonts.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#ex)
 */
export function ex(value) {
  return new Ex(value);
}

/**
 * Represents the [x-height](https://en.wikipedia.org/wiki/X-height) of the
 * root element's `font`. In fonts with the `x` letter, this is generally the height
 * of lowercase letters in the font; `1ex ≈ 0.5em` in many fonts.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#rex)
 */
export function rex(value) {
  return new Rex(value);
}

/**
 * Equal to the used [advance measure](https://developer.mozilla.org/docs/Glossary/Advance_measure)
 * of the "水" glyph (CJK water ideograph, U+6C34), found in the font used to
 * render it.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#ic)
 */
export function ic(value) {
  return new Ic(value);
}

/**
 * Equal to the value of `ic` unit on the root element's font.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#ric)
 */
export function ric(value) {
  return new Ric(value);
}

/**
 * Represents the `font-size` of the root element (typically `<html>`). When
 * used within the root element `font-size`, it represents its initial value.
 * A common browser default is `16px`, but user-defined preferences may
 * modify this.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#rem)
 */
export function rem(value) {
  return new Rem(value);
}

/**
 * Equal to the width or the
 * [advance measure](https://developer.mozilla.org/docs/Glossary/Advance_measure)
 * of the glyph `0` (zero, the Unicode character U+0030) in the root
 * element's `font`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#rch)
 */
export function rch(value) {
  return new Rch(value);
}

/**
 * Equal to the "cap height" (nominal height of capital letters) of the root
 * element's `font`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#rcap)
 */
export function rcap(value) {
  return new Rcap(value);
}

/**
 * Equal to the computed value of the `line-height` property of the element on
 * which it is used, converted to an absolute length. This unit enables length
 * calculations based on the theoretical size of an ideal empty line. However,
 * the size of actual line boxes may differ based on their content.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#lh)
 */
export function lh(value) {
  return new Lh(value);
}

/**
 * Equal to the value of `lh` unit on the root element's font. This unit enables
 * length calculations based on the theoretical size of an ideal empty line.
 * However, the size of actual line boxes may differ based on their content.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#rlh)
 */
export function rlh(value) {
  return new Rlh(value);
}

/**
 * Represents the width or, more precisely, the
 * [advance measure](https://developer.mozilla.org/docs/Glossary/Advance_measure)
 * of the glyph `0` (zero, the Unicode character U+0030) in the element's `font`.
 * In cases where determining the measure of the `0` glyph is impossible or
 * impractical, it must be assumed to be `0.5em` wide by `1em` tall.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/length#ch)
 */
export function ch(value) {
  return new Ch(value);
}

/**
 * Internal function, can be used if you need to go from a Length to a String
 * in case you're building on top of sketch.
 * 
 * @ignore
 */
export function to_string(size) {
  if (size instanceof Px) {
    let value = size[0];
    return $string.append($float.to_string(value), "px");
  } else if (size instanceof Cm) {
    let value = size[0];
    return $string.append($float.to_string(value), "cm");
  } else if (size instanceof Mm) {
    let value = size[0];
    return $string.append($float.to_string(value), "mm");
  } else if (size instanceof Q) {
    let value = size[0];
    return $string.append($float.to_string(value), "q");
  } else if (size instanceof In) {
    let value = size[0];
    return $string.append($float.to_string(value), "in");
  } else if (size instanceof Pc) {
    let value = size[0];
    return $string.append($float.to_string(value), "pc");
  } else if (size instanceof Pt) {
    let value = size[0];
    return $string.append($float.to_string(value), "pt");
  } else if (size instanceof Vh) {
    let value = size[0];
    return $string.append($float.to_string(value), "vh");
  } else if (size instanceof Vw) {
    let value = size[0];
    return $string.append($float.to_string(value), "vw");
  } else if (size instanceof Em) {
    let value = size[0];
    return $string.append($float.to_string(value), "em");
  } else if (size instanceof Rem) {
    let value = size[0];
    return $string.append($float.to_string(value), "rem");
  } else if (size instanceof Lh) {
    let value = size[0];
    return $string.append($float.to_string(value), "lh");
  } else if (size instanceof Rlh) {
    let value = size[0];
    return $string.append($float.to_string(value), "rlh");
  } else if (size instanceof Ch) {
    let value = size[0];
    return $string.append($float.to_string(value), "ch");
  } else if (size instanceof Pct) {
    let value = size[0];
    return $string.append($float.to_string(value), "%");
  } else if (size instanceof Cap) {
    let value = size[0];
    return $string.append($float.to_string(value), "cap");
  } else if (size instanceof Ex) {
    let value = size[0];
    return $string.append($float.to_string(value), "ex");
  } else if (size instanceof Ic) {
    let value = size[0];
    return $string.append($float.to_string(value), "ic");
  } else if (size instanceof Rcap) {
    let value = size[0];
    return $string.append($float.to_string(value), "rcap");
  } else if (size instanceof Rch) {
    let value = size[0];
    return $string.append($float.to_string(value), "rch");
  } else if (size instanceof Rex) {
    let value = size[0];
    return $string.append($float.to_string(value), "rex");
  } else if (size instanceof Ric) {
    let value = size[0];
    return $string.append($float.to_string(value), "ric");
  } else if (size instanceof Vmax) {
    let value = size[0];
    return $string.append($float.to_string(value), "vmax");
  } else if (size instanceof Vmin) {
    let value = size[0];
    return $string.append($float.to_string(value), "vmin");
  } else if (size instanceof Vb) {
    let value = size[0];
    return $string.append($float.to_string(value), "vb");
  } else if (size instanceof Vi) {
    let value = size[0];
    return $string.append($float.to_string(value), "vi");
  } else if (size instanceof Cqw) {
    let value = size[0];
    return $string.append($float.to_string(value), "cqw");
  } else if (size instanceof Cqh) {
    let value = size[0];
    return $string.append($float.to_string(value), "cqh");
  } else if (size instanceof Cqi) {
    let value = size[0];
    return $string.append($float.to_string(value), "cqi");
  } else if (size instanceof Cqb) {
    let value = size[0];
    return $string.append($float.to_string(value), "cqb");
  } else if (size instanceof Cqmin) {
    let value = size[0];
    return $string.append($float.to_string(value), "cqmin");
  } else {
    let value = size[0];
    return $string.append($float.to_string(value), "cqmax");
  }
}
